module.exports = __webpack_public_path__ + "544c9ff6560132c8a9e967982cb107cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/cut_graphic@2x.png
// module id = 848
// module chunks = 0